<template>
  <card>
    <div class="row no-gutters">
      <div class="col-6">
        <div class="row no-gutters">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Hadisə_vaxtı') }}</div>
          <div class="col-8 pd value">{{ item.commAccidentDateStr }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Ərazi') }}</div>
          <div class="col-8 pd value">{{ item.regionName }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('NV_sayı') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.vehicleCount }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Zəncirvari_qəza') }}?</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.commChainAccident === 1 ? $t('Bəli') : $t('Xeyr') }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Daxili_protokol') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.protocol === 1 ? $t('Bəli') : $t('Xeyr') }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Səbəblər') }}</div>
          <div class="col-8 pd value">{{ incidentCauseName }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="row no-gutters">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Hadisə_yeri') }}</div>
          <div class="col-8 pd value">{{ item.commPlace }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Baxış_yeri') }}</div>
          <div class="col-8 pd value">{{ item.observationPlace }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Zərər_vuran') }}</div>
          <div class="col-8 pd value">{{ getVictimText(item.victim) }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('ZBT') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.zbt === 1 ? $t('Bəli') : $t('Xeyr') }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Xəsarət_alan') }}?</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.commInjured === 1 ? $t('Bəli') : $t('Xeyr') }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Əlavə_qeyd') }}</div>
          <div class="col-8 pd value">{{ item.departureResult }}</div>
        </div>
      </div>
    </div>

    <card v-if="item.finishDate" class="mt-2">
      <div class="row no-gutters">
        <span class="rejection-label">{{ $t('Hadisə_QK_tərəfindən_imtina_olunub') }}:</span>
        <div class="col-12">
          <div class="row no-gutters">
            <div :class="['col-2', textLeft, 'pd label']">{{ $t('Səbəb') }}</div>
            <div class="col-10 pd value">{{ item.finishReasonName }}</div>
            
            <div :class="['col-2', textLeft, 'pd label']">{{ $t('Əlavə_qeyd') }}</div>
            <div class="col-10 pd value">{{ item.finishNote }}</div>
          </div>
        </div>
      </div>
    </card>

    <div class="row no-gutters mt-3">
      <div class="col-12">
        <titles :text="$t('Hadisəyə_aid_fayllar')"></titles>
        <hr class="file-divider">
      </div>

      <div class="col-12">
        <upload ref="upload" 
                :sourcetype="1" 
                :sourceId="item.id" 
                :autoupload="true" 
                :disabled="true"
                :downloadAll="true">
        </upload>
      </div>
      
      <div class="col-12">
        <record-label :created="item.createdBy" :updated="item.updatedBy" />
      </div>
    </div>
    
    <google-map ref="mapcontrol" :readonly="true" />
  </card>
</template>

<script>
import { GetIncidentCauses } from "../../services/cls";
import RecordLabel from "./RecordLabel.vue";
import Upload from "./Upload.vue";
import GoogleMap from "./GoogleMap.vue";
import Titles from "./Titles.vue";
import { textLeft } from "../../services/helper";

export default {
  components: {
    Titles,
    RecordLabel,
    Upload,
    GoogleMap
  },
  props: {
    value: Object,
  },
  data() {
    return {
      item: this.value,
      causes: [],
      textLeft: textLeft,
    };
  },
  methods: {
    getIncidentCauses(policyType) {
      GetIncidentCauses(policyType).then((response) => {
        if (response.data) {
          this.causes = response.data;
        } else {
          this.$message({
            type: "error",
            message: this.$t("Xəta_Səbəblər_tapılmadı"),
          });
        }
      });
    },
    map() {
      this.$refs["mapcontrol"].show(this.item.lat, this.item.lng);
    },
    mapObs() {
      this.$refs["mapcontrol"].show(this.item.obslat, this.item.obslng);
    },
    getVictimText(victim) {
      switch(victim) {
        case 1: return this.$t('Sığortalı');
        case 2: return this.$t('Qarşı_tərəf');
        case 3: return this.$t('Naməlum');
        default: return '';
      }
    }
  },
  watch: {
    value() {
      this.item = this.value;
      this.getIncidentCauses(this.item.policyType);
    },
  },
  computed: {
    incidentCauseName() {
      let cause = this.causes.find(item => item.id === this.item.incidentCauseId);
      return cause ? cause.name : this.$t("Təyin_olunmayıb");
    }
  },
  mounted() {
    if (this.value && typeof this.value.policyType !== 'undefined') {
      this.item = this.value;
      this.getIncidentCauses(this.value.policyType);
    }
  },
};
</script>

<style lang="scss" scoped>
.no-gutters {
  margin-right: 0;
  margin-left: 0;
  
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}

.label {
  font-weight: bold;
  color:#3A3A3A !important;
  font-size: var(--font-primary);
}

.value {
  color: #333;
}

.rejection-label {
  color: red;
  margin-left: 17px;
  font-size: 15px;
  padding-bottom: 8px;
  display: block;
}

.file-divider {
  margin-top: 5px;
  height: 1px;
  background: #F3EFE0;
  border: none;
}

.mt-2 {
  margin-top: 8px;
}

.mt-3 {
  margin-top: 16px;
}
</style>